import {
  Center,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useQuery } from "react-query";
import {useNavigate} from "react-router-dom";

import {decodePassword} from "../Api";
import {
  LoginParams,
  useAuthentication,
} from "../hooks/AuthenticationProvider";
import {Paths, SkillType} from "../model/Constants";
import {publicKeys} from "../QueryKeys";
import {extractData} from "../Utils";

const AutoLogin = () => {
  const authentication = useAuthentication();
  const navigate = useNavigate();

  /* example paths:
    https://test.pelex.ucr.ac.cr/autologin?USER_ID=adminS&PASSW=passW
    https://test.pelex.ucr.ac.cr/autologin?TEST=SPEAKING&USER_ID=adminS&PASSW=passW
  */
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get('USER_ID');
  const passwEnconded = urlParams.get('PASSW');
  const testType = urlParams.get('TEST');

  if (userId === null || passwEnconded === null)
    navigate(Paths.LOGIN, { replace: true });

  const passwS = passwEnconded === null ? '' : passwEnconded.trim();
  const username = userId === null ? '' : userId.trim();

  const passwordQuery = useQuery(publicKeys.password(), () =>
    decodePassword(passwS).then(extractData)
  );

  if (passwordQuery.isSuccess && (!authentication.loginMutation ||
                                     authentication.loginMutation.isIdle) ) {
    const password = passwordQuery.data;
    authentication.loginMutation?.mutate({username, password} as LoginParams);
  }

  useEffect(() => {
    if ( authentication.currentUserQuery && authentication.currentUserQuery.data &&
      authentication.currentUserQuery.isSuccess &&
      authentication.currentUserQuery.data.status !== 401
    ) {

      let redirectTo:string = Paths.HOME;
      if (testType !== null && (testType === SkillType.LISTENING.toString() ||
        testType === SkillType.READING.toString() ||
        testType === SkillType.SPEAKING.toString() ||
        testType === SkillType.WRITING.toString())
      ) 
        redirectTo = Paths.HOME_START_TEST.replace(":test", testType)

        navigate(redirectTo, { replace: true });
    }
  }, [authentication.currentUserQuery, testType, navigate]);
  
  return (
    <Center height="200px">
      <Spinner/>
    </Center>
  );
  
};

export default AutoLogin;
